import app from 'new-ui/app';
import { SET_POPUP, SET_CHILD_POPUP } from './constants';

// does not work for the child popup
const handleClosePopup = () => {
  if (app.onpopupclose) {
    app.onpopupclose();
    app.onpopupclose = null;
  }
};

export const setPopup = (payload) => (dispatch, getState) => {
  const { popup: { popup } } = getState();
  if (popup) {
    handleClosePopup();
  }
  dispatch({ type: SET_POPUP, payload });
};

export const setChildPopup = (payload) => ({
  type: SET_CHILD_POPUP, payload,
});

export const closePopup = () => (dispatch, getState) => {
  const { popup: { popup } } = getState();
  if (popup) {
    handleClosePopup();
    dispatch({ type: SET_POPUP, payload: false });
  }
};
